<!-- This is the page a carrier sees when an onboarding link is sent to them -->
<template>
  <div v-if="!mainLoading" class="uk-container uk-margin">
    <h2>Onboarding for {{ onboarderCompany.name }}</h2>
    <img v-if="logo" :src="logo.docFileUrl" class="uk-margin-bottom" />

    <section class="uk-section uk-section-primary">
      <h3>Basic Info</h3>
    </section>
    <!--  TODO: move these 3 sections into their own smaller components so we can re-use in EditShareableProfile    -->
    <div class="uk-text-left uk-padding uk-card uk-card-default">
      <div class="uk-grid uk-child-width-1-1@s uk-child-width-1-3@m">
        <InputField
          label="Company name (*required)"
          v-model="companyInfo.name"
        />
        <InputField label="Email (*required)" v-model="companyInfo.email" />
        <InputField label="MC # (*required)" v-model="companyInfo.mcNum" />
        <InputField label="DOT # (*required)" v-model="companyInfo.dotNum" />
        <InputField label="FID #" v-model="companyInfo.fidNum" />
      </div>
      <hr />
      <div class="uk-grid uk-child-width-1-1@s uk-child-width-1-3@m">
        <InputField
          label="Primary Contact Name"
          v-model="companyInfo.primaryContactName"
        />
        <InputField
          label="Primary Contact Phone #"
          v-model="companyInfo.primaryContactPhoneNumber"
        />
        <InputField
          label="Accounting Email"
          v-model="companyInfo.accountingEmail"
        />
      </div>
      <hr />
      <div class="uk-grid uk-child-width-1-1@s uk-child-width-1-3@m">
        <InputField
          label="Dispatch phone #"
          v-model="companyInfo.dispatchPhone"
        />
        <InputField
          label="After-hours phone # (*required - for emergency only)"
          v-model="companyInfo.afterHoursPhone"
        />
        <InputField label="Fax #" v-model="companyInfo.faxNumber" />
      </div>
      <hr />
      <div class="uk-grid uk-child-width-1-1@s uk-child-width-1-1@m">
        <AddressInputBlock
          requiredLabel="(*required)"
          :address="companyInfo.officeAddress"
        />
      </div>
      <hr />
      <div class="uk-grid uk-child-width-1-1@s uk-child-width-1-3@m">
        <InputField
          label="Number of owner/operator drivers"
          v-model.number="companyInfo.numOwnerOpDrivers"
          type="number"
        />
        <InputField
          label="Number of company drivers"
          v-model.number="companyInfo.numCompanyDrivers"
          type="number"
        />
        <InputField
          label="Preferred lanes"
          v-model="companyInfo.preferredLanes"
        />
      </div>
      <hr />
      <div class="uk-grid">
        <div>
          <label for="tlcheck" class="uk-form-label">We transport TL</label>
          <input
            id="tlcheck"
            type="checkbox"
            label="TL"
            v-model="companyInfo.doesTransportTl"
            class="uk-input uk-form-controls uk-checkbox small-left-margin"
          />
        </div>
        <div>
          <label for="ltlcheck" class="uk-form-label">We transport LTL</label>
          <input
            id="ltlcheck"
            type="checkbox"
            v-model="companyInfo.doesTransportLtl"
            class="uk-input uk-form-controls uk-checkbox small-left-margin"
          />
        </div>
      </div>
      <hr />
      <div class="uk-grid uk-child-width-1-1@s uk-child-width-1-3@m">
        <InputField
          label="Number of tractors"
          v-model.number="companyInfo.numTractors"
          :class="classesEquipInfo"
          type="number"
        />
        <InputField
          label="Number of 45' flat/vans"
          v-model.number="companyInfo.num45FlatVans"
          :class="classesEquipInfo"
          type="number"
        />
        <InputField
          label="Number of 48' flat/vans"
          v-model.number="companyInfo.num48FlatVans"
          :class="classesEquipInfo"
          type="number"
        />
        <InputField
          label="Number of 53' flat/vans"
          v-model.number="companyInfo.num53FlatVans"
          :class="classesEquipInfo"
          type="number"
        />

        <InputField
          label="Number of reefers"
          v-model.number="companyInfo.numReefers"
          :class="classesEquipInfo"
          type="number"
        />
        <InputField
          label="Number of step decks"
          v-model.number="companyInfo.numStepDecks"
          :class="classesEquipInfo"
          type="number"
        />

        <InputField
          label="Number of 4' tarps"
          v-model.number="companyInfo.num4Tarps"
          :class="classesEquipInfo"
          type="number"
        />
        <InputField
          label="Number of 6' tarps"
          v-model="companyInfo.num6Tarps"
          :class="classesEquipInfo"
          type="number"
        />
        <InputField
          label="Number of 8' tarps"
          v-model.number="companyInfo.num8Tarps"
          :class="classesEquipInfo"
          type="number"
        />
        <InputField
          label="Number of coil racks"
          v-model.number="companyInfo.numCoilRacks"
          :class="classesEquipInfo"
          type="number"
        />
        <InputField
          label="Number of pipe stakes"
          v-model.number="companyInfo.numPipeStakes"
          :class="classesEquipInfo"
          type="number"
        />
      </div>
    </div>
    <button
      class="uk-button uk-button-large uk-button-primary uk-form-controls uk-margin-top uk-width-1-3 large-button"
      v-on:click="saveOnboardingInfo"
    >
      <div>Save</div>
    </button>
    <!-- <p class="uk-text-danger uk-text-large">{{ this.submitError }}</p> -->

    <!-- <p class="uk-text-danger uk-text-large">{{ this.submitError }}</p> -->

    <section class="uk-section uk-section-secondary uk-margin-top">
      <h3 class="">Documents to Fill and Sign</h3>
    </section>
    <div
      v-for="doc in infoDocsReqSig"
      :key="doc.id"
      class="uk-card uk-card-default uk-card-body"
    >
      <Button
        v-bind="
          docsSigningIsCompleted[doc.docType]
            ? { isGray: 'true' }
            : { isRed: 'true' }
        "
        :isMediumText="true"
        @click="showSignForm(doc.docType)"
      >
        Sign {{ displayDocTypeName(doc.docType) }}
      </Button>

      <p v-if="docsSigningIsCompleted[doc.docType]" style="color: green">
        <span
          uk-icon="icon: check; ratio: 1.4"
          class="uk-margin-small-right"
        ></span>
        Completed!
      </p>
    </div>

    <section class="uk-section uk-section-muted uk-margin-top">
      <h3>Upload Your Documents</h3>
      <p>PDF files only</p>
    </section>
    <div class="uk-card uk-card-default uk-card-body">
      <div v-if="uploadLoading">
        <div uk-spinner="ratio: 5"></div>
      </div>
      <div v-else class="">
        <p class="uk-text-danger uk-text-large">{{ this.loadFormError }}</p>
        <div
          v-for="(toUploadDoc, idx) of toUploadDocumentTypes"
          :key="idx"
          class="uk-flex uk-flex-center"
        >
          <template v-if="docsToUploadIsUploaded[toUploadDoc.docType]">
            <UploadButton
              @file-uploaded="
                (event) => uploadOnboardingDocument(toUploadDoc.docType, event)
              "
              :uploadText="
                'Re-Upload ' + displayDocTypeName(toUploadDoc.docType)
              "
              :isGray="true"
            />
            <div>Uploaded!</div>
            <!-- <p>Uploaded!</p> -->
          </template>
          <template v-else>
            <UploadButton
              @file-uploaded="
                (event) => uploadOnboardingDocument(toUploadDoc.docType, event)
              "
              :uploadText="
                'Upload ' +
                displayDocTypeName(toUploadDoc.docType) +
                (toUploadDoc.required ? ' (*required)' : ' (optional)')
              "
              :isMediumText="true"
              :isRed="true"
            />
          </template>
        </div>
      </div>
    </div>
    <button
      class="uk-button uk-button-large uk-button-primary uk-form-controls uk-margin-top uk-text-large"
      v-on:click="submitOnboardingInfo"
    >
      Submit Onboarding
    </button>
    <p class="uk-text-danger uk-text-large">{{ this.submitError }}</p>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import UIkit from 'uikit';

import { displayDocTypeNameMixin } from '../../utils/onboarding_docs';
import { addressMixin } from '../../utils/address';
import Button from '../core/Button.vue';
import UploadButton from '../core/UploadButton.vue';
import InputField from '../core/Input/InputField.vue';
import AddressInputBlock from '../core/AddressInputBlock.vue';
import { Address } from '../../types';

import GET_COMPANY_COMPANY_ONBOARDING_DATA from '../../gql/onboarding/CompanyCompanyAssocOnboarding.gql';
import SUBMIT_ONBOARDING_FORM from '../../gql/company/mutations/SubmitOnboardingInfo.gql';
import SAVE_ONBOARDING_FORM from '../../gql/company/mutations/SaveOnboardingInfo.gql';

export default defineComponent({
  name: 'OnboardingForm',
  components: {
    Button,
    UploadButton,
    InputField,
    AddressInputBlock,
  },
  props: {
    userCompanyId: Number,
    carrierCompanyId: Number,
  },
  mixins: [displayDocTypeNameMixin, addressMixin],
  data() {
    return {
      onboarderCompany: null,
      carrierCompany: null,

      // TODO later: sender should be able to specify what docs they want submitted
      toUploadDocumentTypes: [
        { docType: 'authority', docName: 'Authority', required: true },
        { docType: 'insurance', docName: 'Insurance', required: true },
        { docType: 'w9', docName: 'W-9', required: true },
        {
          docType: 'notice_of_assignment',
          docName: 'Notice of Assignment',
          required: false,
        },
      ],

      classesEquipInfo: 'uk-width-1-3',

      submitError: null,

      // Basic info
      companyInfo: {
        name: null,
        mcNum: null,
        dotNum: null,
        fidNum: null,

        primaryContactName: null,
        primaryContactPhoneNumber: null,
        accountingEmail: null,

        officeAddress: {} as Address,
        email: null,

        dispatchPhone: null,
        dispatchContactName: null,
        afterHoursPhone: null,
        faxNumber: null,

        numOwnerOpDrivers: null,
        numCompanyDrivers: null,

        doesTransportTl: false,
        doesTransportLtl: false,

        preferredLanes: null,

        // Equipment
        numTractors: null,
        num45FlatVans: null,
        num48FlatVans: null,
        num53FlatVans: null,

        numReefers: null,
        numStepDecks: null,

        num4Tarps: null,
        num6Tarps: null,
        num8Tarps: null,
        numCoilRacks: null,
        numPipeStakes: null,
      },

      mainLoading: true,
      loading: false,
      uploadLoading: false,
      loadFormError: null,
      textDanger: false,
    };
  },
  computed: {
    logo() {
      const vm = (this as any);

      if (!(this as any).onboarderCompany) return null;

      const logo = (this as any).onboarderCompany.infoDocuments.find(
        (d) => d.docType === 'logo',
      );
      if (logo) return logo;
      else return null;
    },
    infoDocsReqSig() {
      const vm = (this as any);

      if (!(this as any).onboarderCompany) return [];

      console.log('info docs: ', (this as any).onboarderCompany);
      return (this as any).onboarderCompany.infoDocuments.filter(
        (d) => d.needsSignatureWhenOnboarding,
      );
    },
    // Relies on the fact that a broker adds docs to their infoDocuments and that they're only added to the association's onboardingDocs once they're signed
    docsSigningIsCompleted(): any[] {
      const vm = (this as any);

      const existingCompletedOnboardingDocs = (this as any).companyCompanyAssoc
        .onboardingDocs;

      // Check if info doc already exists in onboardingdocs
      const docsReqSigIsCompleted = (this as any).infoDocsReqSig.reduce(
        (statuses, infoDoc) => {
          const alreadySigned = existingCompletedOnboardingDocs.some(
            (completedDoc) => completedDoc.docType === infoDoc.docType,
          );
          statuses[infoDoc.docType] = alreadySigned;
          return statuses;
        },
        {},
      );

      return docsReqSigIsCompleted;
    },

    docsToUploadIsUploaded(): boolean[] {
      const vm = (this as any);

      if (!(this as any).companyCompanyAssoc) return [];

      const existingCompletedOnboardingDocs = (this as any).companyCompanyAssoc
        .onboardingDocs;

      const toUploadStatuses = (this as any).toUploadDocumentTypes.reduce(
        (statuses, toUploadDoc) => {
          const isUploaded = existingCompletedOnboardingDocs.some(
            (completedDoc) => completedDoc.docType === toUploadDoc.docType,
          );
          return { ...statuses, [toUploadDoc.docType]: isUploaded };
        },
        {},
      );

      return toUploadStatuses;
    },
  },
  methods: {
    refreshData() {
      (this as any).$apollo.queries.companyCompanyAssoc.refetch();
    },
    showSignForm(docType: string) {
      const vm = (this as any);

      vm.saveOnboardingInfo();
      vm.$emit('showSignForm', docType, vm.companyInfo);
    },
    loadSavedData() {
      const vm = (this as any);

      const carrier = vm.carrierCompany;
      vm.companyInfo = {
        name: carrier.name,
        mcNum: carrier.mcNumber,
        dotNum: carrier.dotNumber,
        fidNum: carrier.fidNumber,

        primaryContactName: carrier.primaryContactName,
        primaryContactPhoneNumber: carrier.primaryContactPhoneNumber,
        accountingEmail: carrier.accountingEmail,

        officeAddress: {
          streetAddress: carrier.officeAddress?.streetAddress,
          suite: carrier.officeAddress?.suite,
          city: carrier.officeAddress?.city,
          state: carrier.officeAddress?.state,
          zipCode: carrier.officeAddress?.zipCode,
        },
        email: carrier.email,

        dispatchPhone: carrier.dispatchPhoneNumber,
        dispatchContactName: null,
        afterHoursPhone: carrier.afterHoursPhoneNumber,
        faxNumber: carrier.faxNumber,

        numOwnerOpDrivers: carrier.numOwnerOpDrivers,
        numCompanyDrivers: carrier.numCompanyDrivers,

        doesTransportTl: carrier.doesTransportTl,
        doesTransportLtl: carrier.doesTransportLtl,

        preferredLanes: carrier.preferredLanes,

        // Equipment
        numTractors: carrier.numTractors,
        num45FlatVans: carrier.num45FlatVans,
        num48FlatVans: carrier.num48FlatVans,
        num53FlatVans: carrier.num53FlatVans,

        numReefers: carrier.numReefers,
        numStepDecks: carrier.numStepDecks,

        num4Tarps: carrier.num4Tarps,
        num6Tarps: carrier.num6Tarps,
        num8Tarps: carrier.num8Tarps,
        numCoilRacks: carrier.numCoilRacks,
        numPipeStakes: carrier.numPipeStakes,
      };
    },
    uploadOnboardingDocument(documentType, fileUploadEvent) {
      const vm = (this as any);

      const file = fileUploadEvent.target.files[0];
      console.log('file0: ', file.name);
      console.log('documentType', documentType);

      const formData = new FormData();
      formData.append('userCompanyId', vm.userCompanyId.toString());
      formData.append(
        'carrierCompanyId',
        vm.carrierCompanyId.toString(),
      );
      formData.append('documentType', documentType);
      formData.append('file', file);

      vm.uploadLoading = true;

      fetch('/api/onboarding/upload-document', {
        method: 'POST',
        body: formData,
      })
        .then((response) => {
          if (!response.ok) {
            return response.json().then((errMsg) => {
              throw new Error(errMsg.detail);
            });
          }

          return response.json();
        })
        .then((data) => {
          console.log('uploaded file', data);
          vm.refreshData();
          vm.submitError = null;
          vm.loadFormError = null;
          vm.uploadLoading = false;
        })
        .catch((error) => {
          console.error('Upload file err: ', error);
          vm.loadFormError = error;
          vm.uploadLoading = false;
        });
    },

    validateOnboardingFields() {
      const vm = (this as any);

      if (!vm.companyInfo.name) {
        vm.submitError = 'Please enter company name';
        return false;
      } else if (!vm.companyInfo.mcNum) {
        vm.submitError = 'Please enter MC #';
        return false;
      } else if (!vm.companyInfo.dotNum) {
        vm.submitError = 'Please enter DOT #';
        return false;
      } else if (!vm.companyInfo.email) {
        vm.submitError = 'Please enter email address';
        return false;
      } else if (!vm.companyInfo.afterHoursPhone) {
        vm.submitError = 'Please enter after hours phone #';
        return false;
      } else if (
        !vm.validateAddressFieldsExist(
          vm.companyInfo.officeAddress,
        )
      ) {
        vm.submitError = 'Please enter full company address';
        return false;
      }

      for (let i = 0; i < vm.toUploadDocumentTypes.length; i += 1) {
        const docType = vm.toUploadDocumentTypes[i].docType;
        if (
          !vm.docsToUploadIsUploaded[docType] &&
          vm.toUploadDocumentTypes[i].required
        ) {
          vm.submitError = `Please upload your ${vm.displayDocTypeName(
            docType,
          )} form.`;
          return false;
        }
      }

      for (let i = 0; i < vm.infoDocsReqSig.length; i += 1) {
        const docType = vm.infoDocsReqSig[i].docType;
        if (!vm.docsSigningIsCompleted[docType]) {
          vm.submitError = `Please sign the ${vm.displayDocTypeName(
            docType,
          )} form.`;
          return false;
        }
      }

      return true;
    },

    removeEmpty(obj) {
      return Object.fromEntries(
        Object.entries(obj)
          .filter(([_, v]) => v != null)
          // eslint-disable-next-line no-confusing-arrow
          .map(([k, v]) =>
            typeof v === 'object' ? [k, (this as any).removeEmpty(v)] : [k, v],
          ),
      );
    },

    saveOnboardingInfo() {
      const vm = (this as any);

      console.log('COMPANY INFO', vm.companyInfo);

      const carrierInfo = vm.removeEmpty(vm.companyInfo);

      console.log('CARRIER INFO', carrierInfo);

      vm.$apollo
        .mutate({
          mutation: SAVE_ONBOARDING_FORM,
          variables: {
            carrierInfo,
            brokerCompanyId: vm.userCompanyId,
            carrierCompanyId: vm.carrierCompanyId,
          },
        })
        // eslint-disable-next-line
        .then((data) => {
          console.log('submitted onboarding');
          vm.loadFormError = null;
          vm.textDanger = false;
          vm.submitError = null;

          UIkit.notification({
            message: 'Saved!',
            status: 'success',
            timeout: 5000,
          });
        })
        .catch((error) => {
          console.error(`Could not add carrier - error ${error}`);

          vm.loadFormError = error.message;
        });
    },

    submitOnboardingInfo() {
      const vm = (this as any);

      if (!vm.validateOnboardingFields()) {
        return;
      } else {
        vm.submitError = null;
      }

      console.log('COMPANY INFO', vm.companyInfo);

      const carrierInfo = vm.removeEmpty(vm.companyInfo);

      console.log('CARRIER INFO', carrierInfo);

      vm.$apollo
        .mutate({
          mutation: SUBMIT_ONBOARDING_FORM,
          variables: {
            carrierInfo,
            brokerCompanyId: vm.userCompanyId,
            carrierCompanyId: vm.carrierCompanyId,
          },
        })
        // eslint-disable-next-line
        .then((data) => {
          console.log('submitted onboarding');
          vm.loadFormError = null;
          vm.textDanger = false;
          vm.submitError = null;

          // TODO: Create 'submitted' page and tell carrier we've sent docs to broker
          vm.$router.push('/onboarding/complete');
        })
        .catch((error) => {
          console.error(`Could not add carrier - error ${error}`);

          vm.loadFormError = error.message;
        });
    },
  },
  apollo: {
    companyCompanyAssoc: {
      variables() {
        return {
          company1Id: (this as any).userCompanyId,
          company2Id: (this as any).carrierCompanyId,
        };
      },
      query: GET_COMPANY_COMPANY_ONBOARDING_DATA,
      fetchPolicy: 'no-cache',
      update: (data) => data.companyCompanyAssociation,
      result(result) {
        const vm = (this as any);

        console.log('[fetching company data] result: ', result);
        vm.mainLoading = false;
        vm.onboarderCompany =
          result.data.companyCompanyAssociation.company1;
        vm.carrierCompany =
          result.data.companyCompanyAssociation.company2;
        vm.loadSavedData();
      },
      error(error) {
        const vm = (this as any);

        vm.mainLoading = false;
        console.error('Fetching user data failed: ', error);
        vm.errorText = 'new error';
        console.log('err: ', vm.errorText);
      },
    },
    // TODO in future: get the carrier company's existing info and fill it into the onboarding form, so that on subsequent onboardings after the first one, they don't have to re-enter their info all the time. They should only need to sign forms.
  },
} as any);
</script>

<style lang="scss">
.large-button {
  height: 75px;
  font-size: 20px;
}
</style>

<style scoped>
.small-left-margin {
  margin-left: 10px !important;
}
</style>
